'use client';

import { AnimatedButton } from '@/components/ui/animated-button';

export function BrandKitDownloadAction({
  assetUrl,
  downloadName,
}: {
  assetUrl: string;
  downloadName: string;
}): React.ReactNode {
  function handleDownload(): void {
    const link = document.createElement('a');
    link.href = assetUrl;
    link.download = downloadName;
    link.click();
  }

  return (
    <AnimatedButton variant="outline" size="xs" onClick={handleDownload}>
      Download PNG
    </AnimatedButton>
  );
}
